import request from "../request";
import sysrequest from "../sysrequest";
// 水印管理

const api = {
  get_watermark(data) {
    const obj = {
      url: "/bid/demo_v1/watermark/generate/",
      method: "get",
      data,
    };
    // if (data.isSys) return sysrequest(obj);
    // else
    return request(obj);
  },

  post_watermark(data) {
    const obj = {
      url: "/bid/demo_v1/watermark/generate/",
      method: "post",
      data,
    };
    if (data.isSys) return sysrequest(obj);
    else return request(obj);
  },
};
export default api;
